module.exports = __webpack_public_path__ + "static/media/3.8b75d65e.jpg";